import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './HomePage.css'
import Banner from './Banner'
import HeroSection from './HeroSection'
import CollectionSlider from './CollectionSlider'
import SEO from '../SEO'

const HomePage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const restoreY = location.state?.restoreScrollY
    if (typeof restoreY === "number") {
      requestAnimationFrame(() => {
        window.scrollTo(0, restoreY)
      })
      navigate(`${location.pathname}${location.search}`, { replace: true, state: {} })
      return
    }
    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Shotkut – Premium Indian Stock Videos",
    "description": "Browse and download 10,000+ premium HD & 4K Indian stock footage clips. Royalty-free videos of Indian landscapes, culture, festivals, urban life and more.",
    "url": "https://shotkut.com",
    "mainEntity": {
      "@type": "VideoGallery",
      "name": "Indian Stock Video Collection",
      "description": "Curated collection of authentic Indian stock videos in HD & 4K resolution"
    }
  }

  return (
    <main className='w-full px-3 py-4 md:px-4 md:py-2 lg:px-5'>
      <SEO
        title="Premium Indian Stock Videos | HD & 4K Footage"
        description="Shotkut is India's leading stock video platform. Browse and download 10,000+ premium HD & 4K Indian stock footage clips — landscapes, culture, urban life, festivals & more. Royalty-free license."
        keywords="Shotkut, Indian stock videos, Indian stock footage, HD stock videos India, 4K stock footage, royalty-free Indian videos, download stock videos, premium Indian footage, buy stock footage India"
        canonical="/"
        jsonLd={homeJsonLd}
      />

      <Banner />

      <section aria-label="Browse videos">
        <HeroSection />
      </section>

      <CollectionSlider />
    </main>
  )
}

export default HomePage
